<template>
  <CaKpiCards :cards="cards" :columns="3" />
</template>

<script>
import CaKpiCards from '../CaKpiCards.vue'
import { formatMinutes } from '../cleanerActivityUtils'

export default {
  components: { CaKpiCards },
  props: {
    summary: { type: Object, required: true },
  },
  computed: {
    cards() {
      const s = this.summary
      return [
        { key: 'total', label: 'ca_hist_col_total', value: formatMinutes(s.totalGrossMinutes) },
        { key: 'net', label: 'ca_hist_kpi_net', value: formatMinutes(s.totalNetMinutes) },
        { key: 'breaks', label: 'ca_hist_kpi_breaks', value: formatMinutes(s.totalBreakMinutes) },
      ]
    },
  },
}
</script>
